import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'OrderTrackingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/OrderTrackingUI/OrderTrackingUI.vue'),
      remoteEntry: true,
    },
  ],
}
